import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import usePwaInstall from '../hooks/usePwaInstall';
import { isIOS, isInAppBrowser } from '../utils/browser';
import { getActuallyInstalled } from '../utils/pwaInstallCapture';

export default function PwaInstallGuide({ onClose, offsetClass = 'top-[76px]', hideBubble = false }) {
  const { t } = useTranslation();
  const { installState, canInstall } = usePwaInstall();
  const [visible, setVisible] = useState(true);

  let hasGuideFlag = false;
  try {
    hasGuideFlag = sessionStorage.getItem('PWA_INSTALL_GUIDE') === '1';
  } catch (_) {
    hasGuideFlag = false;
  }

  const inApp = isInAppBrowser();
  const isIOSPlatform = isIOS();

  // 3단계: 설치 상태 확정 전 깜빡임 방어 (비동기 판정 중 렌더링 보류 - 인앱 브라우저는 판정 대기 없이 즉시 노출)
  const actuallyInstalled = getActuallyInstalled();
  const isChecking = !inApp && actuallyInstalled === null && !isIOSPlatform && !canInstall;

  if (!visible || !hasGuideFlag || isChecking || installState === 'installed') {
    return null;
  }

  const handleClose = () => {
    setVisible(false);
    try {
      sessionStorage.removeItem('PWA_INSTALL_GUIDE');
    } catch (_) {}
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  // 환경별 안내 문구 결정: 인앱 브라우저는 외부 전환 유도, iOS는 홈 화면 추가 안내, 일반 브라우저는 기본 설치 안내
  const guideText = inApp
    ? t('common.install_guide_inapp')
    : isIOSPlatform
    ? t('common.install_guide_ios')
    : t('common.install_guide_default');

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-40"
        onClick={handleClose}
        aria-hidden="true"
      />
      {!hideBubble && (
        <div
          className={`absolute z-40 ${offsetClass} right-4 max-w-[320px] p-3 bg-surface-container-low/95 backdrop-blur-sm border border-outline-variant/40 rounded-xl shadow-lg cursor-pointer`}
          onClick={handleClose}
        >
          <div className="flex items-start gap-2">
            <p className="flex-1 text-[12px] text-on-surface leading-relaxed break-keep">
              {guideText}
            </p>
            <span className="material-symbols-outlined text-primary text-[16px] shrink-0 mt-0.5">
              arrow_upward
            </span>
          </div>
        </div>
      )}
    </>
  );
}
